import "./contact.css";

import React from "react";
import { Helmet } from "react-helmet";

import { CONTACT } from "../../data/content";
import Reveal from "../general/Reveal";
import ContactForm from "../general/ContactForm";
import { PageBanner, ImageBand, ContactDetails } from "../general/PageParts";

const Contact = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>CONTACT | PM Skillshouse Foundation</title>
      </Helmet>
      <PageBanner title={"CONTACT"} />

      <section className={"container contact-page"}>
        <Reveal variant={"left"}>
          <h2 className={"contact-page-title"}>{CONTACT.pageTitle}</h2>
          <ContactDetails className={"contact-details-page"} />
        </Reveal>
        <Reveal
          variant={"right"}
          delay={0.1}
          className={"contact-page-form"}
        >
          <ContactForm variant={"outlined"} />
        </Reveal>
      </section>

      <ImageBand
        image={"/images/contact_strip.jpg"}
        position={"center 25%"}
      />
    </React.Fragment>
  );
};

export default Contact;
